module.exports = __webpack_public_path__ + "static/media/chat-icon.84ba38b1.png";